import movie from "./movie";
import { combineReducers } from 'redux';

const rootReducer = combineReducers({ movie });

export default rootReducer